import { Store, GetterTree, MutationTree, ActionTree, Module } from "vuex";

import { RootState } from "..";
import { IProductState } from "../states/product-state";
import { IProductCategory } from "../../models/interfaces/product/product-category.model.interface";
import { productService } from "../../services/product.service";
import { IProduct } from "@/models/interfaces/product/product.model.interface";

export const state: IProductState = {
  productCategories: [],
  categoryBrands: []
};

export const getters: GetterTree<IProductState, RootState> = {
  productCategories(state) {
    return state.productCategories;
  },
  categoryBrands(state) {
    return state.categoryBrands;
  }
};

export const mutations: MutationTree<IProductState> = {
  productCategories(state, productCategories: IProductCategory[]) {
    state.productCategories = productCategories;
  },
  categoryBrands(state, categoryBrands: IProduct[]) {
    state.categoryBrands = categoryBrands;
  }
};

export const actions: ActionTree<IProductState, RootState> = {
  async retrieveProductCategories({ commit }) {
    return new Promise((resolve) => {
      productService.getCategories()
        .then((value) => {
          if (value && value.success) {
            commit("productCategories", value.result);
            resolve(value.success);
          }
          resolve(false);
        });
    });
  },
  async retrieveCategoryBrands({ commit }, productCategoryId: number) {
    return new Promise((resolve) => {
      productService.getCategoryBrands(productCategoryId)
        .then((value) => {
          if (value && value.success) {
            commit("categoryBrands", value.result);
            resolve(value.success);
          }
          resolve(false);
        });
    });
  }
};

export const productModule: Module<IProductState, RootState> = {
  state, getters, mutations, actions, namespaced: true
};
